import { render, staticRenderFns } from "./XuanKuaYcPayment.vue?vue&type=template&id=5b9d6727&scoped=true"
import script from "./XuanKuaYcPayment.vue?vue&type=script&lang=js"
export * from "./XuanKuaYcPayment.vue?vue&type=script&lang=js"
import style0 from "./XuanKuaYcPayment.vue?vue&type=style&index=0&id=5b9d6727&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d6727",
  null
  
)

export default component.exports